export const selectStatusOptions = [
    {label: '全部', value: '-1'},
    {label: '未审核', value: '0'},
    {label: '部分审核', value: '1'},
    {label: '完成审核', value: '2'},
    {label: '单卡上线中', value: '3'},
    {label: '二次审核', value: '4'},
    {label: '单卡已上线', value: '5'},
    {label: '组卡已上线', value: '6'},
    {label: '数据清洗中', value: '-3'},
];
export const checkSelectOptions = [
    {value: '-1', label: '全部'},
    {value: '0', label: '未审核'},
    {value: '1', label: '审核通过'},
    {value: '2', label: '审核不通过'},
];

export const selectStatusFilter = (value: number | string) => {
    const tempObj = {} as any;
    selectStatusOptions.map(item => {
        tempObj[item.value] = item.label;
    });
    return tempObj[value + ''] || '--';
};


export const machineReviewFormatter = (value) => {
    const tempObj = {
        '1': '通过',
        '0': '不通过'
    };
    return tempObj[value] || '--';
};

export const PHONE_NUM_EXCEPTION = {
    0: '正常',
    1: '（无区号）',
    2: '（号段异常）'
};
export const getPhoneException = (val) => {
    if (val !== 0) {
        return PHONE_NUM_EXCEPTION[val];
    }
    return '';
};
export const getPhoneAreaInvalid = (type) => {
    if (type === 1) {
        return '（区号异常）';
    }
};
export const verifyStatusOptions = (value) => {
    const tempObj = {
        1: '通过',
        2: '不通过',
        0: '未审核',
    };
    return tempObj[value] || '--';
};

export const weekOption = [
    {name: '周一', value: '周一'},
    {name: '周二', value: '周二'},
    {name: '周三', value: '周三'},
    {name: '周四', value: '周四'},
    {name: '周五', value: '周五'},
    {name: '周六', value: '周六'},
    {name: '周日', value: '周日'},
];
export const weekValue = {
    '周一': 1,
    '周二': 2,
    '周三': 3,
    '周四': 4,
    '周五': 5,
    '周六': 6,
    '周日': 7,
};

export const weekVerify: (value: string) => number = (value: string) => {
    const tempObj = {
        '周一': 1,
        '周二': 2,
        '周三': 3,
        '周四': 4,
        '周五': 5,
        '周六': 6,
        '周日': 7,
    } as any;
    return tempObj[value] || 0;
};